import { swap } from "utils/object";

export const signageTypeValues = {
  Physical: 1,
  Digital: 2,
  Both: 3,
};

export const signageTypeTexts = swap(signageTypeValues);
